<template>
  <v-dialog v-model="dialog" scrollable persistent width="600px">
    <v-card>
      <v-card-title class="admin white--text text-uppercase">
        Huỷ đăng ký
        <v-spacer />
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-6">
        <div class="mb-2">Vui lòng chọn kỳ thi muốn huỷ đăng ký</div>
        <v-select
          v-model="selected"
          label="Chọn kỳ thi muốn huỷ đăng ký"
          :items="items"
          item-text="title"
          item-value="value"
          flat
          outlined
          dense
          hide-details
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-6">
        <v-btn color="grey" outlined variant="text" @click="closeDialog"> Huỷ </v-btn>
        <v-spacer />
        <v-btn :loading="loading" color="admin" outlined variant="text" @click="onConfirm"> Xác nhận </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from 'vuex'
export default {
  data: () => ({dialog: false, selected: null, items: [], loading: false, item: null}),
  methods: {
    ...mapActions({cancelRegisterG10ExamTrial: 'cv/cancelRegisterG10ExamTrial'}),
    openDialog(itemData = {}) {
      this.dialog = true
      this.item = itemData
      this.items = itemData.g10ExamTransactionData.map(value => ({title: `Kỳ ${value}`, value}))
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onConfirm() {
      if (!this.selected) return this.$alert.error('Vui lòng chọn kỳ thi muốn huỷ')
      this.loading = true
      try {
        await this.cancelRegisterG10ExamTrial({id: this.item.id, nth: this.selected})
        this.$alert.success(`Đã huỷ đăng ký cho hồ sơ ${this.item.code} thành công!`)
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>